export default __webpack_public_path__ + "static/media/toolkit.842a51cd.png";